import { useState, useEffect, useContext } from "react";
import { TableRow, TableCell } from "@mui/material";
import { orderTypesArray } from "../../operator_home/Form";
import { PartyAPI, ClaimUpdate } from "../ClaimAPI";
import { EXPIRY_ORDER_TYPE } from "../../../constants";
import { errorToast, getSuccessToast } from "../../../toast";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import FormContext from "../../../context/FormContext";
import "./TableEdit.css";

export const TableEdit = ({ row, setClaimRecord, setEditState }) => {
  const edit_order_type = {
    ZRB: "ZRE",
    ZRB2: "ZRE2",
    ZRI: "ZBI",
    ZMD2: "ZMD1",
    ZPRB: "ZPRE",
    ZVT1: "ZVT2",
    ZRE: "ZRB",
    ZRE2: "ZRB2",
    ZBI: "ZRI",
    ZMD1: "ZMD2",
    ZPRE: "ZPRB",
    ZVT2: "ZVT1",
  };
  const current_order_type_map = [
    row.order_type,
    edit_order_type[row.order_type],
  ];
  const { setIsLoading } = useContext(FormContext);
  const [partyArray, setPartyArray] = useState([]);
  const max_date = new Date().toISOString().split("T")[0];
  // const newRow = JSON.parse(JSON.stringify(row));
  const [otherParty, setOtherParty] = useState({
    disabled: !EXPIRY_ORDER_TYPE.includes(row?.order_type) ? false : true,
  });
  const [party, setParty] = useState({
    name: row.party_master__name,
    customer: row.party_master__customer,
    city: row.party_master__city,
    party_master_id: row.party_master,
    po_number: row.po_number,
    ref_number: row.ref_number,
    ref_date: row.ref_date,
    lr_number: row.lr_number,
    lr_date: row.lr_date,
    received_date: row.received_date,
    open_date: row.open_date,
    case_number: row.case_number,
    transporter_name: row.transporter_name,
    mark_box: row.mark_box,
    submit_status: false,
  });
  const [shipToParty, setShipToParty] = useState({
    current_party: [],
    value: null,
    required: false,
    disabled: true,
  });
  const [itParty, setITParty] = useState({
    current_party: [],
    value: null,
    required: false,
    disabled: true,
  });

  const [salesArea, setSalesArea] = useState({
    current_sales_area: [],
    value: row.sales_area,
    required: false,
    disabled: true,
  });
  const [orderType, setOrderType] = useState({
    value: row.order_type,
  });
  // const allow_mt = !ALLOW_MT.includes(username)
  const axiosPrivate = useAxiosPrivate();

  const update_value = async () => {
    const response = await PartyAPI(axiosPrivate, row.party_master);
    const currentValue = response.data.results.find(
      (value) => value.party_master__customer === value.party_master__customer
    );
    setShipToParty((prev) => ({
      ...prev,
      current_party: currentValue.shipparty_set,
      value: row.ship_party
        ? currentValue.shipparty_set.find(
            (value) => value.partner_number === row.ship_party
          )?.partner_name
        : currentValue.shipparty_set[0]?.partner_number,
    }));
    setITParty((prev) => ({
      ...prev,
      current_party: currentValue.itpartner_set,
      value: row.it_partner
        ? currentValue.shipparty_set.find(
            (value) => value.it_partner === row.it_partner
          )?.it_partner
        : currentValue.itpartner_set[0]?.partner_number,
    }));
    setSalesArea((prev) => ({
      ...prev,
      current_sales_area: currentValue?.sales_area,
    }));
  };

  useEffect(async () => {
    if (EXPIRY_ORDER_TYPE.includes(row.order_type)) {
      return;
    }
    update_value();
  }, []);

  const partyHandler = async (event) => {
    setParty((old) => ({ ...old, name: event.target.value }));
    axiosPrivate
      .get(`/data_entry/partymaster_searchbar/?search=${event.target.value}`)
      .then((res) => {
        setPartyArray(res.data.results);
      });
    const selectedOption = Array.from(event.target.list.options).find(
      (option) => option.value === event.target.value
    );
    if (selectedOption) {
      const currentValue = JSON.parse(
        selectedOption.getAttribute("data-party")
      );
      setParty((prev) => ({
        ...prev,
        name: currentValue.name,
        customer: currentValue.customer,
        city: currentValue.city,
        party_master_id: currentValue.party_master_id,
      }));
      setShipToParty((prev) => ({
        ...prev,
        current_party: currentValue.shipparty_set,
        value: currentValue.shipparty_set[0]?.partner_number,
      }));
      setITParty((prev) => ({
        ...prev,
        current_party: currentValue.itpartner_set,
        value: currentValue.itpartner_set[0]?.partner_number,
      }));
    }
  };

  const shipToPartyHandler = (event) => {
    let selected_ship_party = JSON.parse(event.target.value);
    setShipToParty((obj) => ({
      ...obj,
      value: selected_ship_party.partner_number,
    }));
  };

  const ITPartyHandler = (event) => {
    let selected_it_party = JSON.parse(event.target.value);
    setITParty((obj) => ({ ...obj, value: selected_it_party.partner_number }));
  };

  const SalseAreaHandler = (event) => {
    setSalesArea((obj) => ({ ...obj, value: event.target.value }));
  };

  const orderTypeHandler = (event) => {
    const currentValue = JSON.parse(event.target.value);

    if (orderType.value === "ZRB" && currentValue?.value !== "ZRB") {
      update_value();
    }

    const condiction = !EXPIRY_ORDER_TYPE.includes(currentValue?.value);
    setOrderType((pre) => ({ ...pre, value: currentValue.value }));
    setOtherParty((pre) => ({ ...pre, disabled: condiction ? false : true }));
  };

  const changeHandler = (event) => {
    setParty((prev) => ({ ...prev, [event.target.name]: event.target.value }));
    if (event.target.name === "mark_box") {
      setParty((prev) => ({
        ...prev,
        [event.target.name]: event.target.checked,
      }));
    }
  };

  const clearHandler = () => {
    setEditState((prev) => ({ ...prev, status: false, id: null }));
  };

  const Submithandler = async (event) => {
    event.preventDefault();
    setParty((prev) => ({ ...prev, submit_status: true }));
    setIsLoading(true);
    const payload = {
      po_number: party.po_number,
      order_type: orderType.value,
      party_master: party.party_master_id,
      mark_box: party.mark_box,
      lr_number: party.lr_number,
      lr_date: party.lr_date,
      case_number: party.case_number,
      received_date: party.received_date,
      open_date: party.open_date,
      ref_number: party.ref_number,
      ref_date: party.ref_date,
      transporter_name: party.transporter_name,
    };
    if (!otherParty.disabled) {
      Object.assign(payload, {
        ship_party: parseInt(shipToParty.value)
          ? parseInt(shipToParty.value).toString()
          : null,
        it_partner: parseInt(itParty.value)
          ? parseInt(itParty.value).toString()
          : null,
        sales_area: salesArea.value,
      });
    }
    try {
      const response = await ClaimUpdate(
        axiosPrivate,
        payload,
        row.stockists_master_id
      );
      if (response.status === 200) {
        getSuccessToast("Claim Update Succesfully");
        setClaimRecord((record) =>
          record.map((current) =>
            current.stockists_master_id === row.stockists_master_id
              ? {
                  ...current,
                  po_number: party.po_number,
                  order_type: orderType.value,
                  order_types: [orderType.value],
                  party_master: party.party_master_id,
                  party_master__name: party.name,
                  party_master__customer: party.customer,
                  party_master__city: party.city,
                  mark_box: party.mark_box,
                  lr_number: party.lr_number,
                  lr_date: party.lr_date,
                  case_number: party.case_number,
                  received_date: party.received_date,
                  open_date: party.open_date,
                  ref_number: party.ref_number, // Corrected from ref_date to ref_number
                  ref_date: party.ref_date,
                  transporter_name: party.transporter_name,
                  ship_party: parseInt(shipToParty.value)
                    ? parseInt(shipToParty.value)
                    : null,
                  it_partner: parseInt(itParty.value)
                    ? parseInt(itParty.value)
                    : null,
                  sales_area: salesArea.value,
                }
              : current
          )
        );
      }
    } catch (error) {
      if (error.status !== 200) {
        errorToast(
          `Failed to Update claim: error ${error.response.status}`,
          2000
        );
      }
      if (error.response) {
        errorToast(
          `Failed to Update claim: error ${error.response.status}`,
          2000
        );
      } else {
        errorToast("Failed to Update claim: unknown error", 2000);
      }
    } finally {
      setParty((prev) => ({ ...prev, submit_status: false }));
      setIsLoading(false);
      clearHandler();
    }
  };

  return (
    <TableRow>
      <TableCell colSpan="16">
        <form className="edit__claim__form" onSubmit={Submithandler}>
          <div>
            <label htmlFor="aushadhai_number">Aushadhai No.</label>
            <input
              type="text"
              disabled={true}
              id="aushadhai_number"
              defaultValue={row.stockists_master_id
                .toString()
                .padStart(10, "0")}
            />
          </div>
          <div>
            <label htmlFor="po_number">Po No.</label>
            <input
              type="text"
              onChange={changeHandler}
              defaultValue={row.po_number}
              id="po_number"
              name="po_number"
            />
          </div>
          <div>
            <label htmlFor="order_type">Order Type:</label>
            <select
              required
              name="order_type"
              id="order_type"
              onChange={orderTypeHandler}
              defaultValue={JSON.stringify(
                orderTypesArray.find(
                  (orderType) => orderType.value === row.order_type
                )
              )}
            >
              {orderTypesArray.map(
                (row) =>
                  current_order_type_map.includes(row.value) && (
                    <option
                      key={row.value}
                      value={JSON.stringify(row)}
                      disabled={row.status}
                    >
                      {row.value}
                    </option>
                  )
              )}
            </select>
          </div>
          <div>
            <label htmlFor="party_master__name">Party Name</label>
            <input
              required={true}
              id="party_master__name"
              name="party_master__name"
              list="party-name"
              onChange={partyHandler}
              onFocus={partyHandler}
              value={party.name}
            />
            <datalist id="party-name">
              {partyArray &&
                partyArray.map((party) => (
                  <option
                    key={party.party_master_id}
                    data-party={JSON.stringify(party)}
                    value={`${party.customer} | ${party.name} | ${party.city}`}
                  ></option>
                ))}
            </datalist>
          </div>
          <div>
            <label htmlFor="party__code">Party Code</label>
            <input
              id="party__code"
              name="party__code"
              type="text"
              disabled={true}
              value={party.customer}
            />
          </div>
          <div>
            <label htmlFor="party__city">Party Code</label>
            <input
              id="party__city"
              name="party__city"
              type="text"
              disabled={true}
              value={party.city}
            />
          </div>
          <div>
            <label htmlFor="ship__party__code">Ship To Party:</label>

            <select
              onChange={shipToPartyHandler}
              name="ship_party"
              id="ship_party"
              disabled={otherParty.disabled}
              required={false}
              defaultValue={JSON.stringify(
                shipToParty.current_party.find(
                  (party) => party.partner_number === row?.ship_party
                )
              )}
            >
              {shipToParty.current_party &&
                shipToParty.current_party.map((record, idx) => (
                  <option key={idx} value={JSON.stringify(record)}>
                    {record.partner_number}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label htmlFor="it_partner">IT Party:</label>

            <select
              onChange={ITPartyHandler}
              name="it_partner"
              id="it_partner"
              disabled={otherParty.disabled}
              required={false}
              defaultValue={JSON.stringify(
                itParty.current_party.find(
                  (party) => party.partner_number === row?.ship_party
                )
              )}
            >
              {itParty.current_party &&
                itParty?.current_party.map((row, idx) => (
                  <option key={idx} value={JSON.stringify(row)}>
                    {row.partner_number} | {row.partner_name}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label htmlFor="sales__area">Sales Area:</label>

            <select
              onChange={SalseAreaHandler}
              name="sales_area"
              id="sales__area"
              disabled={otherParty.disabled}
              required={!otherParty.disabled}
              value={salesArea.value}
            >
              {salesArea.current_sales_area &&
                salesArea?.current_sales_area.map((row) => (
                  <option key={row} value={row}>
                    {row}
                  </option>
                ))}
            </select>
          </div>
          <div className="edit__claim__form__button">
            <input
              type="submit"
              value="Update"
              disabled={party.submit_status}
            />
          </div>
          <div>
            <label htmlFor="status">Status:</label>
            <input
              type="checkbox"
              id="status"
              checked={party.mark_box}
              name="mark_box"
              onChange={changeHandler}
            />
          </div>
          <div>
            <label htmlFor="ref_number">Claim No:</label>
            <input
              onChange={changeHandler}
              required={true}
              defaultValue={row.ref_number}
              type="text"
              id="ref_number"
              name="ref_number"
            />
          </div>
          <div>
            <label htmlFor="ref_date">Claim Date:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="date"
              defaultValue={row.ref_date}
              min="1995-01-01"
              max={max_date}
              id="ref_date"
              name="ref_date"
            />
          </div>
          <div>
            <label htmlFor="lr__number">LR No:</label>
            <input
              onChange={changeHandler}
              required={true}
              defaultValue={row.lr_number}
              type="text"
              id="lr__number"
              name="lr_number"
            />
          </div>
          <div>
            <label htmlFor="lr_date">LR Date:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="date"
              name="lr_date"
              id="lr_date"
              min="1995-01-01"
              max={row.received_date ? max_date : row.received_date}
              defaultValue={row.lr_date}
            />
          </div>
          <div>
            <label htmlFor="received_date">Received Date:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="date"
              id="received_date"
              name="received_date"
              min="1995-01-01"
              max={max_date}
              defaultValue={row.received_date}
            />
          </div>
          <div>
            <label htmlFor="open_date">Open Date:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="date"
              id="open_date"
              name="open_date"
              min="1995-01-01"
              max={max_date}
              defaultValue={row.open_date}
            />
          </div>
          <div>
            <label htmlFor="case_number">Case No:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="text"
              name="case_number"
              id="case_number"
              defaultValue={row.case_number}
            />
          </div>
          <div>
            <label htmlFor="transporter_name">Trans Name:</label>
            <input
              onChange={changeHandler}
              required={true}
              type="text"
              name="transporter_name"
              id="transporter_name"
              defaultValue={row.transporter_name}
            />
          </div>
          <div className="edit__claim__form__button">
            <input
              type="button"
              value="Cancel"
              onClick={clearHandler}
              disabled={party.submit_status}
            />
          </div>
        </form>
      </TableCell>
    </TableRow>
  );
};
